import React, { lazy } from 'react';
import { Hero } from '../components/home/Hero';
import { SignGrid } from '../components/home/SignGrid';
import { Problema } from '../components/home/Problema';
import { Solucion } from '../components/home/Solucion';
import { ComoFunciona } from '../components/home/ComoFunciona';
import { ParaQuien } from '../components/home/ParaQuien';
import { Reviews } from '../components/home/Reviews';
import { Productos } from '../components/home/Productos';
import { FAQ } from '../components/home/FAQ';
import { Disclaimer } from '../components/home/Disclaimer';
const PROBLEMA_SOLUCION_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/Wo_P7B_zdv8m9RvhXj7oHsrVCD8DHmoaCV8LM93AvU4jwAaKiGqzNwGb4XYEagB9_tZ0TcHraHRe_tnjw_TqjyQZxuHl5rbrSK5lMOirgN3ahHy_2wo6yUvf1xmSggU58NRTNKzMv.jpg?v=1778629047';
export function Home() {
  return <div className="w-full" data-id="element-402">
      <Hero data-id="element-403" />
      <SignGrid data-id="element-404" />

      {/* Combined background for Problema + Solución */}
      <div className="relative" data-id="element-405">
        <div className="absolute inset-0 z-0" data-id="element-406">
          <img src={PROBLEMA_SOLUCION_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-407" />
          {/* Dark overlay for legibility */}
          <div className="absolute inset-0 bg-cosmic-black/75" data-id="element-408" />
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.55) 25%, rgba(5,5,8,0.55) 75%, #050508 100%)'
        }} data-id="element-409" />
        </div>
        <div className="relative z-10" data-id="element-410">
          <Problema data-id="element-411" />
          <Solucion data-id="element-412" />
        </div>
      </div>

      <ComoFunciona data-id="element-413" />
      <ParaQuien data-id="element-414" />
      <Reviews data-id="element-415" />
      <Productos data-id="element-416" />
      <FAQ data-id="element-417" />
      <Disclaimer data-id="element-418" />
    </div>;
}